import { HISTORY_PURCHASE_INFO } from "../types/HistoryPurchase";

export const fetchHistoryPurchase = (userId, token) => ({
    type: HISTORY_PURCHASE_INFO,
    payload: { userId, token },
  });
  